﻿import { ProjectMilestoneStatus } from "@/enums";

export const disableToggle = (status) =>
  status === ProjectMilestoneStatus.InApproval ||
  status === ProjectMilestoneStatus.Approved;
